/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceCountTenant {
    getFixupPrototypeFunction() { return ResourceCountTenant.fixupPrototype; }

    static newInstance(model: Partial<ResourceCountTenant>): ResourceCountTenant {
        let obj = Object.assign(new ResourceCountTenant(), model);
        ResourceCountTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceCountTenant>): ResourceCountTenant {
        if (!model) return null;
        return ResourceCountTenant.newInstance(<ResourceCountTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceCountTenant) {
        if (!obj) return;

        models.ResourceCountTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceCountTenant): boolean {
        Object.setPrototypeOf(obj, ResourceCountTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.open === undefined) {
            this.open = 0;
        }
    }

    /**
     * The resources that are open based on the recommendation
     */
    open: number;

}
